import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IRiskTemplateListItem, RiskTemplateListItem } from "./riskTemplateListItem";

export interface IRiskTemplateListItems extends ListItems<IRiskTemplateListItem> {
}

export class RiskTemplateListItems extends ListItems<RiskTemplateListItem> implements IRiskTemplateListItems {
    constructor();
    constructor(obj: IRiskTemplateListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RiskTemplateListItem);
    }
}